/**
 * @file リーダーの「ふつうの読む画面」へ戻る導線である (ヘッダーの操作の先頭)。
 *
 * @what: パネル・範囲を囲む・ページに書き込む・選んで聞く のどれかが出ているとき
 *   「読むだけにもどる」を出す。押すと全部たたんで紙面だけに戻す。
 *   選んだものは消さずに残し、たたんでいる間は「選択中 n件」で数を出して、押すと質問の欄が
 *   戻る。その右の×で選択そのものを外す。
 * @why: AI に聞いたあと、パネルや選択が残ったままになり、どこにいるのか分からなくなる
 *   (代表の指摘、2026-09-11)。出口を1か所に決め、いまがふつうの読む画面でないことも
 *   同じボタンで伝える。
 * @failure: 描画のみ。状態は呼び出し側が持つ。
 */

import "./study.css";

export function ReaderPlainBar({
  offPlain,
  onPlain,
  askCount,
  onShowAsk,
  onClearAsk,
}: {
  /** ふつうの読む画面から外れているか (外れているときだけ「読むだけにもどる」を出す)。 */
  offPlain: boolean;
  onPlain: () => void;
  /** たたんでいる選択の数である。ひとつも無ければ「選択中」は出さない。 */
  askCount: number;
  /** たたんだ質問の欄を戻す。 */
  onShowAsk: () => void;
  /** 選んだものを外す。 */
  onClearAsk: () => void;
}) {
  if (!offPlain && askCount === 0) return null;
  return (
    <span className="study-viewer-group" role="group" aria-label="読む画面にもどる">
      {offPlain ? (
        <button type="button" className="study-viewer-btn study-viewer-btn--plain" onClick={onPlain}>
          読むだけにもどる
        </button>
      ) : null}
      {askCount > 0 ? (
        <span className="study-viewer-picked">
          <button
            type="button"
            className="study-viewer-picked-btn"
            aria-label={`選択中の${askCount}件について聞く欄を開く`}
            onClick={onShowAsk}
          >
            選択中 {askCount}件
          </button>
          <button
            type="button"
            className="study-viewer-picked-clear"
            aria-label="選んだものを全部外す"
            onClick={onClearAsk}
          >
            <span aria-hidden="true">×</span>
          </button>
        </span>
      ) : null}
    </span>
  );
}
